export default "__VITE_ASSET__0a7fe4db__$_?nuxt_component=async__"